import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import ComplexityList from './ComplexityList'
import ComplexityOverride from './ComplexityOverride'
import RateCardList from './RateCardList'
import RateCardOverride from './RateCardOverride'

export default function BadRoute() {
    return (
        <main style={{ padding: "1rem" }}>
            <Grid container spacing={1} alignItems="stretch">
            <Grid item xs={4} >
              <Paper style={{height: "100%"}}>
                <ComplexityList />
              </Paper>
            </Grid>
            <Grid item xs={8}>
              <Paper style={{height: "100%"}}>
                <ComplexityOverride />
              </Paper>
            </Grid>
            <Grid item xs={12} >
                <Divider style={{ background: 'black'  }} />
            </Grid>
            <Grid item xs={4}>
              <Paper style={{height: "100%"}}>
                <RateCardList />
              </Paper>
            </Grid>
            <Grid item xs={8}>
              <Paper style={{height: "100%"}}>
                <RateCardOverride />
              </Paper>
            </Grid>
            </Grid>
        </main>
    );
}